import {SET_MESSAGE, EMPTY_MESSAGE, SET_LANGUAGE} from "../mutation-types"

const state = {
	message: '',
	variant: '',
	language: localStorage.getItem('language') || null,
}

const getters = {
	hasMessage: state => state.message !== null && state.message !== undefined && state.message !== '',
	getMessage: state => state.message,
	getVariant: state => !!state.variant ? state.variant : '',
	getLanguage: state => state.language,
}

const actions = {
	[SET_MESSAGE]: ({commit, dispatch}, data) => {
		return new Promise((resolve, reject) => {
			commit(SET_MESSAGE, data)
			resolve()
		})
	},
	[EMPTY_MESSAGE]: ({commit, dispatch}) => {
		return new Promise((resolve, reject) => {
			commit(EMPTY_MESSAGE)
			resolve()
		})
	},
	[SET_LANGUAGE]: ({commit, dispatch}, data) => {
		return new Promise((resolve, reject) => {
			commit(SET_LANGUAGE, data)
			resolve()
		})
	},
}

const mutations = {
	[SET_MESSAGE]: (state, data) => {
		state.message = data.message
		state.variant = data.variant
	},
	[EMPTY_MESSAGE]: (state) => {
		state.message = ''
		state.variant = ''
	},
	[SET_LANGUAGE]: (state, data) => {
		state.language = data
		localStorage.setItem('language', state.language)
	}
}

export default {
	state,
	getters,
	actions,
	mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/global.js